export default {
    send_welcome_email_title: "Send Credentials Email",
    send_welcome_email_success_message: "The credentials has been sent",
    send_welcome_email_error_message: "The credentials could not be sent due to an error",
    send_welcome_email_message: "The current actions is going to generate a new password and sent the onboarding email to the customer, Do you want to proceed?",
    send_welcome_email_label: "Send Credentials",
    send_welcome_email_disabled: "Send welcome email need to be turned on on the account configuration"
};